module.exports = __webpack_public_path__ + "img/arrow-left.a254a2b5.svg";